<template>
  <div class="history-page">
    <div class="history-page-max">
      <el-carousel indicator-position="outside">
        <el-carousel-item
          v-for="(history, parentIndex) in allHistoryData"
          :key="parentIndex"
        >
          <div class="step-box">
            <div class="step">
              <div
                class="step-item"
                v-for="(item, index) in history.top"
                :key="item.year"
              >
                <div class="step-item-dot active">
                  <div
                    class="step-item-event"
                    ref="stepBlockRef"
                    @mouseleave="onWrapperOut('top', index,parentIndex)"
                  >
                    <div
                      class="step-item-wrapper"
                      @mouseover="onWrapperOver('top', index,parentIndex)"
                    >
                      <div class="title">{{ item.year }} <span class="unit">年</span></div>
                      <div class="content" v-for="(h, i) in item.list" :key="i">
                        <span class="index-dot"></span>
                        <span class="text">{{ h.text }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="step-item-dot"></div>
                <div class="step-item-dot"></div>
                <div class="step-item-dot"></div>
                <div class="step-item-dot"></div>
                <div class="step-item-dot active step-item-bottom-dot">
                  <!-- bottom 是否存在 -->
                  <div
                    class="step-item-event"
                    v-if="history.bottom[index]"
                    ref="stepBlockBottomRef"
                    @mouseleave="onWrapperOut('bottom', index,parentIndex)"
                  >
                    <div
                      class="step-item-wrapper"
                      @mouseover="onWrapperOver('bottom', index,parentIndex)"
                    >
                    <div class="title">{{ history.bottom[index].year }} <span class="unit">年</span></div>
                    <div
                      class="content"
                      v-for="(h, i) in history.bottom[index].list"
                      :key="i"
                    >
                      <span class="index-dot"></span>
                      <span class="text">{{ h.text }}</span>
                    </div>
                  </div>
               
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="history-page-min">
      <div class="history-wrapper">
        <div
          class="history-wrapper-item"
          v-for="item in foldData"
          :key="item.year"
        >
          <div class="item-left">
            <div class="dot"></div>
          </div>
          <div class="item-right">
            <div class="item-right-title">
              {{ item.year }} <span class="unit">年</span>
            </div>
            <div class="content" v-for="(h, i) in item.list" :key="i">
              <span class="index-dot"></span>
              <span class="text">{{ h.text }}</span>
            </div>
          </div>
        </div>
        <div class="history-footer" @click="onFold">
          {{ foldText }}
          <i
            :class="
              foldText === '展开全部'
                ? 'el-icon-arrow-down'
                : 'el-icon-arrow-up'
            "
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chunk } from 'lodash';
export default {
  name: 'AboutHistory',

  data() {
    return {
      active: 0,
      visible: true,
      historyData: [
        {
          year: '2025',
          list: [
            { text: '全面拥抱 Ai，推出 原生 AI Agent：Aidee。' },
            { text: '进入大健康，教育领域，赋能门店超千家。' },
          ],
        },
        {
          year: '2024',
          list: [
            { text: '发布销冠 CRM 个人版本（“有牌面” 赋能超级个体）' },
            { text: '与众菱集团合作，首个汽车 SaaS 产品落地' },
            { text: '推出城市中台效果付费服务，首年 GMV 过亿' },
          ],
        },
        {
          year: '2023',
          list: [
            { text: '获深圳市 “专精特新” 企业认定' },
            { text: '通过 CMMI3 国际认证' },
            { text: '销冠 CRM 品牌发布，APP正式上线' },
          ],
        },
        {
          year: '2022',
          list: [
            { text: '完成 C2 轮融资（招商创投投资）' },
            { text: '与中科院深圳先进院共创元宇宙空间计算联合实验室' },
          ],
        },
        {
          year: '2021',
          list: [
            { text: '完成C1轮融资（火山石投资领投、同创伟跟投）' },
            { text: '云创营销场景覆盖率超95%，服务用户破亿' },
            { text: '获“地产数字力TOP20科技领军企业”奖' },
            { text: '与循环智能达成 战略合作' },
            { text: '公司10周年，全面升级品牌使命、愿景、价值观' },
          ],
        },
        {
          year: '2020',
          list: [
            { text: '营销云小程序上线超100个，疫情期间实现规模化赋能行业' },
            { text: '斩获“人工智能金炼奖” (智能战“疫”成果)' },
            { text: '成为 腾讯企微首家地产营销服务商' },
            { text: '思为营销云上线超300个，与8家TOP20开发商建立 区域/集团合作' },
            { text: '入选“年度地产智慧营销新物种”' },
          ],
        },
        {
          year: '2019',
          list: [
            { text: '完成B轮融资（朗玛峰领投、同创伟业和微禾跟投），员工参与认股；' },
            { text: '入选首期腾讯SaaS加速器，获腾讯全生态扶持；' },
            { text: '与碧桂园共建“凤凰云创新营销联合实验室”。' },
          ],
        },
        {
          year: '2018',
          list: [
            { text: '提出“流态营销”理论，定义地产营销2.0时代' },
            { text: '海外拓展至纽约、伦敦、澳洲等标标项目' },
          ],
        },
        {
          year: '2017',
          list: [
            { text: '获国家高新技术企业认证' },
            { text: '完成A+轮融资（同创伟业投资）' },
          ],
        },
        {
          year: '2016',
          list: [
            { text: '完成A轮融资（朗玛峰投资）' },
            { text: '斩获中经联盟年度战略合作伙伴奖' },
          ],
        },
        {
          year: '2015',
          list: [
            { text: '完成 天使轮融资' },
            { text: '设立深圳、海口等分支机构' },
          ],
        },
        {
          year: '2013',
          list: [
            { text: '革命性多点触控平台亮相 美国InfoComm，获广泛好评' },
          ],
        },
        {
          year: '2012',
          list: [
            { text: '获移动触控售楼软件著作权 & 广东省 “双软企业”认证' },
            { text: '思为移动触控售楼软件获软件著作权登记，获广东省 “双软企业” 认证' },
          ],
        },
        {
          year: '2011',
          list: [
            { text: '公司成立，启动 Idea-Make 售楼系统研发，进军地产数字化领域' },
          ],
        },
      ],
      foldText: '展开全部',
      mobileLimit: 3,
      stepBlockRef: null,
      stepBlockBottomRef: null,

      pageSize: 8
    };
  },
  computed: {
    // 每页有8个，上下各4个
    allHistoryData() {
      const arr = chunk(this.historyData, this.pageSize);
      return arr.map((item) => {
        const topArr = [];
        const bottomArr = [];
        item.map((el, i) => {
          if (i % 2 === 0) {
            topArr.push(el);
          } else {
            bottomArr.push(el);
          }
        });
        return {
          top: topArr,
          bottom: bottomArr,
        };
      });
    },
    foldData() {
      if (this.foldText === '展开全部') {
        return this.historyData.slice(0, 3);
      }
      return this.historyData;
    },
  },
  methods: {
    onFold() {
      window._hmt.push([
        '_trackEvent',
        'button',
        'click',
        `移动端关于我们发展历程展开收起`,
      ]);
      this.foldText = this.foldText === '展开全部' ? '收起' : '展开全部';
    },

    // 解决hover反复抖动的问题
    onWrapperOut(type, index,parentIndex) {
      const refIndex = parentIndex * this.pageSize /2 + index
      if (type === 'top') {
        this.$refs.stepBlockRef[refIndex].style.transform = 'translateY(0)';
      } else {
        this.$refs.stepBlockBottomRef[refIndex].style.transform = 'translateY(0)';
      }
    },
    onWrapperOver(type, index,parentIndex) {
   
      const refIndex = parentIndex * this.pageSize /2 + index
      if (type === 'top') {
        this.$refs.stepBlockRef[refIndex].style.transform = 'translateY(-10px)';
      } else {
        this.$refs.stepBlockBottomRef[refIndex].style.transform =
          'translateY(10px)';
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.history-page {
  margin-top: 10px;
  width: 100%;
  // height: 724px;
  position: relative;
  &-img {
    // width: 100%;
    position: absolute;
    // top: -175px;
    // height: 100%;
    width: 1200px;
    // height: calc(648px - 175px);
  }
  .history-page-min {
    display: none;
  }
  .step {
    position: relative;
    display: flex;
    // justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 14px 14px 14px 30px;
    &-item {
      font-size: 20px;
      color: #878a90;
      cursor: pointer;
      display: flex;
      z-index: 2;
      &-dot {
        display: block;
        width: 12px;
        height: 12px;
        background: #a6c4ff;
        border-radius: 50%;
        margin-left: 26px;
        &:first-child {
          margin-left: 0;
        }
      }
      &-bottom-dot {
        margin-right: 60px;
      }
    }
    &-box {
      position: absolute;
      top: 50%;
      margin-left: 15px;
      transform: translateY(-50%);
    }
  }
  .step::after {
    content: '';
    height: 1px;
    width: calc(100% - 84px);
    background: #5597fd;
    position: absolute;
    left: 30px;
    top: 20px;
    z-index: 1;
  }
  .active {
    font-size: 22px;
    font-weight: 500;
    color: #2d2e30;
    &.step-item-dot {
      position: relative;
      width: 16px;
      height: 16px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(55, 119, 246, 0.7);
      border: 1px solid #3777f6;
      top: -2px;
    }

    &.step-item-dot::after {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      background: linear-gradient(180deg, #3777f6 0%, #5597fd 100%);
      border-radius: 50%;
      position: absolute;
      margin: auto;
      top: 0px;
      left: 0;
      bottom: 0;
      right: 0;
    }
    .step-item-wrapper {
      // margin: 12px;
      // margin-bottom: 24px;
      height: 100%;
      box-sizing: border-box;
      .unit{
          font-size: 16px;
          font-family: DINAlternate-Bold, DINAlternate;
          margin-left: -4px;
        }
    }
    .step-item-event {
      position: absolute;
      width: 250px;
      height: 320px;
      background: #fff;
      top: -336px;
      left: -20px;
      padding: 12px;
      box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
      // box-shadow: 8px 8px 20px 0px red;
      border-radius: 4px;
      .title {
        font-weight: bold;
        color: #2d2e30;
        font-size: 26px;
        font-family: DINAlternate-Bold, DINAlternate;
    
      }
      .content {
        font-size: 14px;
        font-weight: 400;
        color: #5a5c60;
        margin-top: 8px;
        &:first-child {
          margin-top: 0px;
        }
        .index-dot {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: linear-gradient(180deg, #3777f6 0%, #5597fd 100%);
          margin-right: 8px;
          vertical-align: middle;
        }
      }
      .title-month {
        font-weight: 500;
        color: #2d2e30;
        margin-right: 8px;
      }
      &::after {
        content: ' ';
        position: absolute;
        left: 12px;
        width: 0;
        height: 0;
        border-top: 20px solid #fff;
        border-right: 15px solid transparent;
        border-left: 15px solid transparent;
        bottom: -10px;
      }
      // &:hover {
      //   transform: translateY(-10px);
      // }
    }
    &.step-item-bottom-dot {
      // top: 350px;
      .step-item-event {
        top: 30px;
        left: -215px;
        &::after {
          border-bottom: 20px solid #fff;
          border-right: 15px solid transparent;
          border-left: 15px solid transparent;
          border-top: 0px solid transparent;
          top: -10px;

          bottom: 0px;

          left: 207px;
        }
        // &:hover {
        //   transform: translateY(10px);
        // }
      }
    }
  }
  // 通用：移动端与桌面端都适用
  .history-page-min .item-right .content .index-dot {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: linear-gradient(180deg, #3777f6 0%, #5597fd 100%);
    margin-right: 8px;
    vertical-align: middle;
  }
  ::v-deep .el-carousel {
    // width: 400px;
    .el-carousel__container {
      // margin-top: 40px;
      height: 780px;
      .el-carousel__arrow {
        display: none;
      }
    }
    .el-carousel__indicator {
      padding: 0;
      width: 20px;
      margin-right: 40px;
      margin-top: 10px;
      .el-carousel__button {
        background: #3777f6;
        width: 52px;
        margin-right: 24px;
      }
    }
  }
}

// 移动端布局
@import '@/views/about/min-about';
</style>
